import { render, staticRenderFns } from "./AppletDetail.vue?vue&type=template&id=55da0277&"
import script from "./AppletDetail.vue?vue&type=script&lang=js&"
export * from "./AppletDetail.vue?vue&type=script&lang=js&"
import style0 from "./AppletDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports